import styled from 'styled-components';
import { Button } from '../../../styles';

export const Nav = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 0;
    width: 100%;
    height: 72px;
    z-index: 3;
    background-color: ${props => props.theme.primaryDarkBlue};
    font-family: ${props => props.theme.sansSerif};
    >div {
        display: flex;
        align-items: center;
    }
    @media screen and (max-width: 1050px) {
        flex-direction: column;
        justify-content: center;
        height: 13%;
        >div {
            flex-wrap: wrap;
        }
    }
`;

export const Firm = styled.span`
    display: flex;
    align-items: center;
    text-align: center;
    color: #fff;
    position: static;
    height: 25px;
    left: 20px;
    top: 12px;
    padding: 0 12px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    font-family: ${props => props.theme.sansSerif};
    >span {
        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 0px 10px;
    }
`;

export const NavButton = styled(Button)`
    justify-content: space-around;
    font-family: ${props => props.sansSerif};
    font-weight: 500;
    font-size: ${props => props.theme.smallFont};
    font-style: normal;
    line-height: 18px;
    border-radius: 25px;
    padding: 8px 20px;
    border: ${props => props.border ? '1px solid #fff' : 'none' };
    color: white;
    height: 38px;
    background-color: ${props => props.theme.primaryDarkBlue};
    transition: 0.3s ease;
    &:hover {
        background: #fff;
        color: ${props => props.theme.primaryDarkBlue};
    }
    ${props => props.selected && `
        background: #fff;
        color: ${props.theme.primaryDarkBlue};
    `};
    &:focus {
        outline: none;
    }
    &:disabled {
        color: grey;
        border: 1px solid grey;
    }
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 8px;
`;

NavButton.defaultProps = {
    border: true
};

export const TogglePresentationButton = styled.button`
    color: ${({selected}) => selected ? '#007bff' : '#6c757d'};
    border: none;
    background-color: transparent;
    cursor: pointer;
    &hover {
        text-decoration: underline;
    }
`;

export const InfoDropdown = styled.ul`
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 11;
    justify-content: center;
    list-style-type: none;
    border: 1px solid grey;
    border-radius: 5px;
    padding: 10px;
    align-items: flex-start;
    position: absolute;
    background: #ffff;
    margin: 0;
    min-width: 130px;
    font-size: ${props => props.theme.smallFont};
    li:nth-of-type(1),
    li:nth-of-type(2) {
        padding: 5px 5px 5px 10px;
    }
`;

